















































































import { Component, Vue } from 'vue-property-decorator';
import VxBreadcrumb from '@/layouts/components/VxBreadcrumb.vue';
import BookingComponent from '@/components/common/BookingComponent.vue';
import router from '@/router';
import AuthModule from '@/store/AuthModule';

@Component({
    components: {
    },
})
export default class AfterLoginSelector extends Vue {

    getService(): string | null {
        return localStorage.getItem('service');
    }

    setStateService(service: string) {
    localStorage.setItem('service', service);
    
    // Redirection différente selon le service sélectionné
    if (service === 'immo') {
        return this.$router.push({ name: 'homePrescriber' });
    } else if (service === 'credit') {
        return this.$router.push({ name: 'CreditRequest' });
    } else if (service === 'lead') {
        return this.$router.push({ name: 'DataRequest' });
    } else {
        // Cas par défaut si besoin
        return this.$router.push({ name: 'createProspect' });
    }
    }
}
